export default __webpack_public_path__ + "static/media/eye.353103ba.svg";